import { getBackVersion } from '../../config';
import {
    LandlordAreaPropertySnapshot,
    LandlordAreaSplitSnapshot,
} from '../../models/LandlordArea';
import api from '../api';

const getProperties = (): Promise<LandlordAreaPropertySnapshot[]> =>
    api.request<LandlordAreaPropertySnapshot[]>({
        method: 'GET',
        url: `${getBackVersion()}/landlord_area/properties`,
    });

const getPropertySplits = (
    propertyId: number
): Promise<LandlordAreaSplitSnapshot[]> =>
    api.request<LandlordAreaSplitSnapshot[]>({
        method: 'GET',
        url: `${getBackVersion()}/landlord_area/properties/${propertyId}/splits`,
    });

export { getProperties, getPropertySplits };
